import { getBaseBOUrl } from '~/utils/apiRequest/base';

export const nodeBackDomain = getBaseBOUrl();

export const NODE_BACK_URL = `https://${nodeBackDomain}`;

export const BASE_PROXY_API = '/api/proxy/';

export const PROXY_CORE_PATH = `${BASE_PROXY_API}core/`;
